import { client } from '@/api/client';
import { GetAutoBadgeDelegateType, GetAutoBadgeDelegateTypeResponse } from '@/api/dtos';
import useSWRMutation from 'swr/mutation';

async function getAutoBadgeDelegateTypeFetcher(
    _key: string,
    { arg }: { arg: GetAutoBadgeDelegateType }
): Promise<GetAutoBadgeDelegateTypeResponse> {
    return (await client.post(arg)) as GetAutoBadgeDelegateTypeResponse;
}

export const useGetAutoBadgeDelegateType = () => {
    const { trigger, data, error, isMutating } = useSWRMutation(
        'GetAutoBadgeDelegateType',
        getAutoBadgeDelegateTypeFetcher
    );

    return {
        getAutoBadgeDelegateType: trigger,
        data,
        error,
        pending: isMutating,
    };
};

export default useGetAutoBadgeDelegateType;
